import { useEffect, useRef, useState } from 'react';

export default function CTASection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative w-full min-h-[500px] md:min-h-[600px] overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=warm%20golden%20abstract%20background%20with%20soft%20bokeh%20light%20organic%20shapes%20amber%20and%20honey%20tones%20elegant%20minimalist%20texture%20luxury%20aromatic%20essence%20atmosphere%20no%20text&width=1400&height=800&seq=cta-bg&orientation=landscape)',
        }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full min-h-[500px] md:min-h-[600px] px-6 text-center py-20">
        <div
          className={`transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <p className="text-white/90 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10">
            El compromiso con la excelencia y la flexibilidad son las fuerzas motrices de nuestra empresa.
          </p>
          <a
            href="mailto:comercial@esenciayco.co"
            className="inline-block px-10 py-4 border border-white/60 text-white text-sm tracking-widest uppercase transition-all duration-300 hover:bg-white hover:text-gray-900"
          >
            Conectemos
          </a>
        </div>
      </div>
    </section>
  );
}